import COMMON_FIELDS from "src/general/constants/commonFields";
import { FetchBaseQueryMeta } from "@reduxjs/toolkit/query";
import IServerResponse from "src/business.InterfaceLayer/store/types/ServerResponse.type";

export type ApiResponse<
	T extends IServerResponse<{
		[COMMON_FIELDS.DTO]: T[COMMON_FIELDS.DATA][COMMON_FIELDS.DTO] | null;
	}>
> = T[COMMON_FIELDS.DATA] | null;

export type FromDtoServiceObject<Raw, Extra extends object | null> = {
	[COMMON_FIELDS.DTO]: Raw | null;
} & Extra;

export type FromDtoExtra<
	T extends IServerResponse<
		FromDtoServiceObject<T[COMMON_FIELDS.DATA][COMMON_FIELDS.DTO], any>
	>
> = Omit<T[COMMON_FIELDS.DATA], COMMON_FIELDS.DTO>;

export const convertToServerResponse = <
	T extends {
		[COMMON_FIELDS.DATA]: {
			[COMMON_FIELDS.DTO]: T[COMMON_FIELDS.DATA][COMMON_FIELDS.DTO];
		};
	}
>(
	props: T[COMMON_FIELDS.DATA][COMMON_FIELDS.DTO] | null,
	meta: FetchBaseQueryMeta,
	extra?: FromDtoExtra<T>,
	other?: Omit<IServerResponse<T>, COMMON_FIELDS.DATA | COMMON_FIELDS.STATUS>
): IServerResponse<
	FromDtoServiceObject<
		T[COMMON_FIELDS.DATA][COMMON_FIELDS.DTO],
		FromDtoExtra<T>
	>
> =>
	({
		[COMMON_FIELDS.DATA]: {
			[COMMON_FIELDS.DTO]: props,
			...extra,
		},
		[COMMON_FIELDS.STATUS]: meta.response?.status,
		...other,
	} as IServerResponse<
		FromDtoServiceObject<
			T[COMMON_FIELDS.DATA][COMMON_FIELDS.DTO],
			FromDtoExtra<T>
		>
	>);
